import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "style", "autoSize", "width", "height", "getContent"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { useSingleton } from '@tencent/glue-react-use';
import { usePrefixCls } from '../../../config/hooks/usePrefixCls';
import { GaugeRender } from '../lib/GaugeRender';
import { GaugeContentWrapper } from './GaugeContentWrapper';
var FULL_SIZE_STYLE = {
  width: '100%',
  height: '100%'
};
var CANVAS_STYLE = {
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0
};
export var Gauge = function Gauge(props) {
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    _props$autoSize = props.autoSize,
    autoSize = _props$autoSize === void 0 ? true : _props$autoSize,
    _props$width = props.width,
    width = _props$width === void 0 ? 300 : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 300 : _props$height,
    getContent = props.getContent,
    gaugeOptions = _objectWithoutProperties(props, _excluded);
  var panelPrefix = usePrefixCls('gauge-panel');
  var renderer = useSingleton(function () {
    return new GaugeRender(gaugeOptions.ratio || window.devicePixelRatio);
  });
  renderer.updateOptions(gaugeOptions);
  React.useEffect(function () {
    return function () {
      renderer.dispose();
    };
  }, []);
  var domStyle = _objectSpread(_objectSpread({
    position: 'relative'
  }, style), autoSize ? FULL_SIZE_STYLE : {
    width: width,
    height: height
  });
  return React.createElement("div", {
    className: "".concat(panelPrefix, " ").concat(className),
    style: domStyle
  }, React.createElement("canvas", {
    style: CANVAS_STYLE,
    ref: renderer.onElementRef
  }), getContent && React.createElement(GaugeContentWrapper, {
    getContent: getContent,
    renderer: renderer
  }));
};